import { render } from "./user-list.vue?vue&type=template&id=dd438b08&ts=true"
import script from "./user-list.vue?vue&type=script&lang=ts"
export * from "./user-list.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__